module.exports = __webpack_public_path__ + "media/images/sp/maedori_photowedding/soudan_stores@2x-31018eae932b733a0bc9f698a4d7a38c.webp";